<div id="mauticform_wrapper_acessoempresa2" class="mauticform_wrapper">
    <form #form1 autocomplete="false" role="form" method="post" action="{{formApiUrl}}?formId=24"
        id="mauticform_acessoempresa2" data-mautic-form="acessoempresa2" enctype="multipart/form-data">
        <div class="mauticform-error" id="mauticform_acessoempresa2_error"></div>
        <div class="mauticform-message" id="mauticform_acessoempresa2_message"></div>
        <div class="mauticform-innerform">


            <div class="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">

                <div id="mauticform_acessoempresa2_nome_completo" data-validate="nome_completo"
                    data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-1 mauticform-required">

                    <input id="mauticform_input_acessoempresa2_nome_completo" name="mauticform[nome_completo]"
                        [value]="formData.fullname" class="mauticform-input" type="text">

                </div>

                <div id="mauticform_acessoempresa2_email" data-validate="email" data-validation-type="email"
                    class="mauticform-row mauticform-email mauticform-field-2 mauticform-required">

                    <input id="mauticform_input_acessoempresa2_email" name="mauticform[email]" [value]="formData.email"
                        class="mauticform-input" type="email">

                </div>

                <div id="mauticform_acessoempresa2_telefone" data-validate="telefone" data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-3 mauticform-required">

                    <input id="mauticform_input_acessoempresa2_telefone" name="mauticform[telefone]"
                        [value]="formData.phone" class="mauticform-input" type="text">

                </div>

                <div id="mauticform_acessoempresa2_senha" data-validate="senha" data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-4 mauticform-required">

                    <input id="mauticform_input_acessoempresa2_senha" name="mauticform[senha]"
                        [value]="formData.password" class="mauticform-input" type="text">

                </div>

                <div id="mauticform_acessoempresa2_cpf" data-validate="cpf" data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-5">

                    <input id="mauticform_input_acessoempresa2_cpf" name="mauticform[cpf]"
                        [value]="formData.taxDocumentNumber" class="mauticform-input" type="text">

                </div>

                <div id="mauticform_acessoempresa2_tipo_de_usuario" data-validate="tipo_de_usuario"
                    data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-6 mauticform-required">

                    <input id="mauticform_input_acessoempresa2_tipo_de_usuario" name="mauticform[tipo_de_usuario]"
                        value="company" class="mauticform-input" type="text">

                </div>

                <div id="mauticform_acessoempresa2_sobrenome" class="mauticform-row mauticform-text mauticform-field-7">
                    <input id="mauticform_input_acessoempresa2_sobrenome" name="mauticform[sobrenome]" [value]="formData.lastname" class="mauticform-input" type="text">
                </div>
    
                <div id="mauticform_acessoempresa2_genero" class="mauticform-row mauticform-text mauticform-field-8">
                    <input id="mauticform_input_acessoempresa2_genero" name="mauticform[genero]" [value]="formData.gender" class="mauticform-input" type="text">
                </div>
    

                <div id="mauticform_acessoempresa2_submit"
                    class="mauticform-row mauticform-button-wrapper mauticform-field-5">
                    <button type="submit" name="mauticform[submit]" id="mauticform_input_acessoempresa2_submit" value=""
                        class="mauticform-button btn btn-default">Enviar</button>
                </div>
            </div>
        </div>

        <input type="hidden" name="mauticform[formId]" id="mauticform_acessoempresa2_id" value="24">
        <input type="hidden" name="mauticform[return]" id="mauticform_acessoempresa2_return" value="">
        <input type="hidden" name="mauticform[formName]" id="mauticform_acessoempresa2_name" value="acessoempresa2">

    </form>
</div>